// extracted by mini-css-extract-plugin
module.exports = {"chat":"Message_chat__2qP-D"};